import { selectUserHasResponded } from 'domains/app/selectors'
import { useSelector } from 'react-redux'

export const useUserHasResponded = () => useSelector(selectUserHasResponded)
